import script from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&setup=true&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=538ef8e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538ef8e7"]])

export default __exports__